import React, { useEffect, useState } from "react";

import "./stylesMargin.css";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      beginAtZero: true,
      stacked: false,
    },
    y: {
      stacked: false,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
      anchor: "end",
      align: "start",
      formatter: (value) => value.toLocaleString(),
      color: "black",
      font: {
        family: "Poppins-regular",
        weight: "bold",
      },
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value * 100)}%`;
        },
      },
    },
  },
};

function Margin() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isLoading, setIsLoading] = useState(false);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("day")];
  const [dates, setDates] = useState(thisMonthRange);

  const [allDates, setAllDates] = useState([]);
  const [marginData, setMarginData] = useState([]);

  const data = {
    labels: allDates,
    datasets: [
      {
        label: "Margin",
        data: marginData,
        backgroundColor: "#6177E8",
        borderRadius: 5,
      },
      
    ],
  };

  const getMarginByBetTypeData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      setIsLoading(true);
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_MARGIN_DATA,
        params
      );

      const data = response?.data?.data?.data;
      const marginData = data.map((item) => item.margin);

      const allDates = data.map((item) => item.date);

      setAllDates(allDates);
      setMarginData(marginData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMarginByBetTypeData(dates, false);
  }, []);

  return (
    <div className="margin-container">
      <div className="margin-header">
        <h2>Margin</h2>
        <CustomDatePicker
          getData={getMarginByBetTypeData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>

      <div className="margin-chart">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="margin-chart-container">
              <Bar data={data} options={options} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Margin;
